import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker-icon-stadium",
  "use": "spr-marker-icon-stadium-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"spr-marker-icon-stadium\"><path fill-rule=\"evenodd\" fill=\"#FFF\" d=\"M13 24H0V0h18v24h-5zm-2-2v-2H7v2h4zm0-20H7v2h4V2zm5 0h-3v4H5V2H2v9h3.142C5.589 9.279 7.141 8 9 8s3.411 1.279 3.858 3H16V2zM7 12c0 1.102.897 2 2 2 1.102 0 2-.898 2-2 0-1.103-.898-2-2-2-1.103 0-2 .897-2 2zm9 1h-3.142c-.447 1.721-1.999 3-3.858 3s-3.411-1.279-3.858-3H2v9h3v-4h8v4h3v-9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker-icon-stadium.svg
// module id = 269
// module chunks = 0